module.exports = __webpack_public_path__ + "static/media/cheltenham-italic-700.d53eaf3b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/cheltenham-italic-700.woff
// module id = 278
// module chunks = 0